import { useState, useEffect } from "react";
import { getCities } from "../api/taxonomy";

// Custom hook for debounced city search
export const useCitySearch = (query, delay = 300, includeInactive = false) => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!query || query.trim() === "") {
      setCities([]);
      return;
    }

    const fetchCities = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getCities(query, includeInactive);
        // API returns: { success: true, count, data: [...] }
        setCities(response.data || []);
      } catch (err) {
        console.error("Failed to fetch cities", err);
        setError(err.message || "Failed to fetch cities");
        setCities([]);
      } finally {
        setLoading(false);
      }
    };

    const handler = setTimeout(() => {
      fetchCities();
    }, delay);

    return () => clearTimeout(handler);
  }, [query, delay, includeInactive]);

  return { cities, loading, error, setCities };
};
